<script setup lang="ts">
import BusinessManagement from "@/views/playground/planner/business-management/BusinessManagement.vue";
</script>

<template>
  <business-management></business-management>
</template>

<style scoped></style>
